import axios from 'axios'
import { message, Modal, notification } from 'ant-design-vue'
import moment from 'moment'
import store from '../store'
import db from 'utils/localstorage'
moment.locale('zh-cn')

// 统一配置
let FEBS_REQUEST = axios.create({
  baseURL: '/api/',
  // baseURL: "http://172.18.30.196:9527",
  // baseURL: 'http://172.18.10.71:9527',
  // baseURL: 'http://172.18.1.113:8201/api',//测试地址
  // baseURL: 'http://172.18.1.68:9527',
  // baseURL: "http://172.18.30.180:9527",
  // baseURL: "http://172.18.30.191:9527",// 伟雄
  responseType: 'json',
  validateStatus(status) {
    // 200 外的状态码都认定为失败
    return status === 200
  }
})
// 拦截请求
FEBS_REQUEST.interceptors.request.use(
  config => {
    let expireTime = store.state.account.expireTime
    let now = moment().format('YYYYMMDDHHmmss')
    // 让token早10秒种过期，提升“请重新登录”弹窗体验
    if (now - expireTime >= -10) {
      // Modal.error({
      //   title: '登录已过期',
      //   content: '很抱歉，登录已过期，请重新登录',
      //   okText: '重新登录',
      //   mask: false,
      //   onOk: () => {
      //     return new Promise((resolve, reject) => {
      //       db.clear()
      //       location.reload()
      //     })
      //   }
      // })
      db.clear()
      location.reload()
    }
    // 有 token就带上
    if (store.state.account.token) {
      config.headers.Authentication = store.state.account.token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 拦截响应
FEBS_REQUEST.interceptors.response.use(
  config => {
    return config
  },
  error => {
    if (error.response) {
      let errorMessage =
        error.response.data === null
          ? '系统内部异常，请联系网站管理员'
          : error.response.data.message
      switch (error.response.status) {
        case 404:
          notification.error({
            message: '系统提示',
            description: '很抱歉，资源未找到',
            duration: 4
          })
          break
        case 403:
          notification.warn({
            message: '系统提示',
            description: '很抱歉，您无法访问该资源，可能是因为没有相应权限',
            duration: 4
          })
          break
        // case 401:
        //   Modal.error({
        //     title: '登录已过期',
        //     content: '很抱歉，登录已过期，请重新登录',
        //     okText: '重新登录',
        //     mask: false,
        //     onOk: () => {
        //       return new Promise((resolve, reject) => {
        //         db.clear()
        //         location.reload()
        //       })
        //     }
        //   })
        //   setTimeout(() => {
        //     db.clear()
        //     location.reload()
        //   }, 3000)
        //   break
        default:
          notification.error({
            message: '系统提示',
            description: errorMessage,
            duration: 4
          })
          break
      }
    }
    return Promise.reject(error)
  }
)

const request = {
  post(url, params) {
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = ''
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                '=' +
                encodeURIComponent(params[key]) +
                '&'
            }
          })
          return result
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  put(url, params) {
    return FEBS_REQUEST.put(url, params, {
      transformRequest: [
        params => {
          let result = ''
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                '=' +
                encodeURIComponent(params[key]) +
                '&'
            }
          })
          return result
        }
      ],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    })
  },
  get(url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return FEBS_REQUEST.get(`${url}${_params}`)
  },
  delete(url, params) {
    let _params
    if (Object.is(params, undefined)) {
      _params = ''
    } else {
      _params = '?'
      for (let key in params) {
        if (params.hasOwnProperty(key) && params[key] !== null) {
          _params += `${key}=${params[key]}&`
        }
      }
    }
    return FEBS_REQUEST.delete(`${url}${_params}`)
  },
  export(url, params = {}, fileName = '导出数据.xlsx') {
    const hide = this.$message.loading('下载中···', 0)
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = ''
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                '=' +
                encodeURIComponent(params[key]) +
                '&'
            }
          })
          return result
        }
      ],
      responseType: 'blob'
    })
      .then(r => {
        const content = r.data
        const blob = new Blob([content])
        // const fileName = `${new Date().getTime()}_导出结果.xlsx`
        // console.log(r.headers)
        const myfileName = fileName
        let filename = ''
        console.log('下载--》》》', r.headers['content-disposition'])
        // 如果后端返回文件名就用后端返回的，如果没有返回就用自定义的
        if (r.headers['content-disposition']) {
          filename = decodeURI(
            r.headers['content-disposition'].split(';')[1].split('=')[1]
          )
        } else {
          filename = myfileName
        }
        console.log(window.navigator)
        if ('download' in document.createElement('a')) {
          if ('msSaveOrOpenBlob' in window.navigator) {
            navigator.msSaveOrOpenBlob(blob, filename)
          } else {
            const elink = document.createElement('a')
            elink.download = filename
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          }
          // this.$message.success('导出成功', 1)
        } else {
          navigator.msSaveBlob(blob, fileName)
        }
        setTimeout(hide, 10)
      })
      .catch(r => {
        console.error(r)
        setTimeout(hide, 10)
        message.error('下载失败')
      })
  },
  download(url, params, filename) {
    message.loading('文件传输中')
    return FEBS_REQUEST.post(url, params, {
      transformRequest: [
        params => {
          let result = ''
          Object.keys(params).forEach(key => {
            if (
              !Object.is(params[key], undefined) &&
              !Object.is(params[key], null)
            ) {
              result +=
                encodeURIComponent(key) +
                '=' +
                encodeURIComponent(params[key]) +
                '&'
            }
          })
          return result
        }
      ],
      responseType: 'blob'
    })
      .then(r => {
        const content = r.data
        const blob = new Blob([content])
        if ('download' in document.createElement('a')) {
          const elink = document.createElement('a')
          elink.download = filename
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          navigator.msSaveBlob(blob, filename)
        }
      })
      .catch(r => {
        console.error(r)
        message.error('下载失败')
      })
  },
  upload(url, params) {
    return FEBS_REQUEST.post(url, params)
  },
  submit(url, params) {
    return FEBS_REQUEST.post(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  putEdit(url, params) {
    return FEBS_REQUEST.put(url, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js